import { useEffect, useState } from "react";
import type { ProjectImportJob } from "~/projectImportStore";
import { resolveNextProjectImportExpiryAt } from "./cloudProjectImportJobs.logic";

export function useProjectImportExpiryClock(jobs: readonly ProjectImportJob[]): number {
  const [nowMs, setNowMs] = useState(Date.now);
  const nextExpiryAt = resolveNextProjectImportExpiryAt(jobs, nowMs);

  useEffect(() => {
    if (nextExpiryAt === null) return;
    const timeout = globalThis.setTimeout(
      () => setNowMs(Date.now()),
      Math.max(0, nextExpiryAt - Date.now()),
    );
    return () => globalThis.clearTimeout(timeout);
  }, [nextExpiryAt]);

  return nowMs;
}
